/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Note_MemberInputs */



/**
* | output |
* | --- |
* | "Chats in this project are private. You only see the chats you started. Your chats, the files you attach in them and the documents the AI creates in them are ..." |
*
* @param {Project_Private_Chats_Note_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_note_member = /** @type {((inputs?: Project_Private_Chats_Note_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Note_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Chats in diesem Projekt sind privat. Sie sehen nur die Chats, die Sie selbst gestartet haben. Ihre Chats, die Dateien, die Sie darin anhängen, und die Dokumente, die die KI darin erstellt, sehen nur Sie, die Projekt-Admins und Mitglieder, die die Chats aller Mitglieder sehen dürfen. Die eigenen Dateien des Projekts bleiben für alle Mitglieder sichtbar, ebenso ältere Dateien und Dokumente aus Chats, die entstanden sind, bevor es diese Funktion gab.")
	return /** @type {LocalizedString} */ ("Chats in this project are private. You only see the chats you started. Your chats, the files you attach in them and the documents the AI creates in them are visible only to you, to project admins and to members allowed to see everyone's chats. The project's own files stay visible to all members, and so do older files and documents from chats, made before this feature existed.")
});